import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ClinicProgramsPage from '@/pages/ClinicProgramsPage';
import Storefront from '@/pages/Storefront';
import Subscriptions from '@/pages/Subscriptions';
import ClinicProducts from '@/components/clinic/ClinicProducts';
import { useSearchParams } from 'react-router-dom';

const ProgramsPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'programs';

  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value }, { replace: true });
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">Programs</h1>
        <p className="text-sm text-slate-500 mt-1">Manage clinic programs, storefront, subscriptions, and products.</p>
      </div>

      <Tabs defaultValue={defaultTab} onValueChange={handleTabChange} className="w-full">
        <TabsList className="border-b border-slate-200 bg-transparent h-auto p-0 space-x-0 w-full justify-start rounded-none">
          <TabsTrigger
            value="programs"
            className="rounded-none border-b-2 border-transparent px-4 py-2.5 text-sm font-medium text-slate-500 hover:text-slate-700 data-[state=active]:border-brand-teal data-[state=active]:text-slate-900 data-[state=active]:bg-transparent data-[state=active]:shadow-none transition-colors"
          >
            Programs
          </TabsTrigger>
          <TabsTrigger
            value="storefront"
            className="rounded-none border-b-2 border-transparent px-4 py-2.5 text-sm font-medium text-slate-500 hover:text-slate-700 data-[state=active]:border-brand-teal data-[state=active]:text-slate-900 data-[state=active]:bg-transparent data-[state=active]:shadow-none transition-colors"
          >
            Storefront
          </TabsTrigger>
          <TabsTrigger
            value="subscriptions"
            className="rounded-none border-b-2 border-transparent px-4 py-2.5 text-sm font-medium text-slate-500 hover:text-slate-700 data-[state=active]:border-brand-teal data-[state=active]:text-slate-900 data-[state=active]:bg-transparent data-[state=active]:shadow-none transition-colors"
          >
            Subscriptions
          </TabsTrigger>
          <TabsTrigger
            value="products"
            className="rounded-none border-b-2 border-transparent px-4 py-2.5 text-sm font-medium text-slate-500 hover:text-slate-700 data-[state=active]:border-brand-teal data-[state=active]:text-slate-900 data-[state=active]:bg-transparent data-[state=active]:shadow-none transition-colors"
          >
            Products
          </TabsTrigger>
        </TabsList>

        <div className="mt-6">
          <TabsContent value="programs" className="m-0">
            <ClinicProgramsPage />
          </TabsContent>
          <TabsContent value="storefront" className="m-0">
            <Storefront />
          </TabsContent>
          <TabsContent value="subscriptions" className="m-0">
            <Subscriptions />
          </TabsContent>
          <TabsContent value="products" className="m-0">
            <ClinicProducts />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
};

export default ProgramsPage;
